import { useEffect, useReducer } from 'react';
import { toast } from 'react-toastify';
import { getUniversalBtn, updateUniversalBtn } from '~/api/universalButton';
import CobuConstants from '~/helpers/cobuConstants';
import universalButtonSlice, {
  hideLoader,
  initialState,
  loader,
  setUniversalButtonData
} from '~/reducers/universalButton';
import { CreateUniversalButtonBody } from '~/types/universalButton';

export default (buttonId: string) => {
  const [universalButtonState, dispatch] = useReducer(
    universalButtonSlice,
    initialState
  );

  useEffect(() => {
    fetchUniversalButton();
  }, []);

  /*Data Logics*/
  const fetchUniversalButton = async (refresh = false) => {
    try {
      dispatch(
        loader({
          loadingString: refresh
            ? CobuConstants.activeUniversalButtons.refreshingUniversalButton
            : CobuConstants.activeUniversalButtons.fetchingUniversalButton
        })
      );

      const response = await getUniversalBtn(buttonId);
      dispatch(setUniversalButtonData(response.data));
    } catch (error) {
      if (error?.message) {
        toast(error?.message);
      }
    } finally {
      dispatch(hideLoader());
    }
  };

  const updateUniversalButton = async (button: CreateUniversalButtonBody) => {
    try {
      dispatch(
        loader({
          loadingString:
            CobuConstants.activeUniversalButtons.editUniversalButtonLoading
        })
      );

      await updateUniversalBtn(button);
      await fetchUniversalButton(true);
    } catch (error) {
      if (error?.message) {
        toast(error?.message);
      }
    } finally {
      dispatch(hideLoader());
    }
  };

  return {
    universalButtonState,
    fetchUniversalButton,
    updateUniversalButton
  };
};
